import Alpine from 'alpinejs'
import axios from 'axios'
import smoothscroll from 'smoothscroll-polyfill'
import collapse from '@alpinejs/collapse'

Alpine.plugin(collapse)

smoothscroll.polyfill()

Alpine.data('siteNav', () => ({
    smoothScrollTo(id) {
        if (!id) {
            return
        }
        const target = document.getElementById(id)
        const siteNavHeight = this.$root.offsetHeight
        const targetTop = target.getBoundingClientRect().top + window.pageYOffset - siteNavHeight
        window.scroll({
            top: targetTop,
            left: 0,
            behavior: 'smooth',
        })
    }
}))

Alpine.data('kontakt', () => ({
    isSending: false,
    success: false,
    errors: {},
    handleSubmit() {
        this.isSending = true
        this.errors = {}
        this.success = false

        axios
            .post(this.$el.action, new FormData(this.$el))
            .then(({ data }) => {
                console.log(data)
                this.success = data.success
                this.errors = data.errors
                this.isSending = false

                const offset = 100
                const targetTop = this.$el.getBoundingClientRect().top + window.pageYOffset - offset
                window.scroll({
                    top: targetTop,
                    left: 0,
                    behavior: 'smooth',
                })
            })
            .catch(error => {
                this.success = false
                this.errors = {
                    general: 'Leider ist ein Fehler aufgetreten',
                }
                this.isSending = false
            })
    },
    hasErrors() {
        let errors = { ...this.errors }
        // delete errors.general

        if (errors == null) return false
        if (typeof errors !== 'object') return false
        if (JSON.stringify(errors) === '{}') return false

        return true
    }
}))

Alpine.start()
